import { render } from "./DependenciasMap.vue?vue&type=template&id=fbe141ec&scoped=true"
import script from "./DependenciasMap.vue?vue&type=script&lang=js"
export * from "./DependenciasMap.vue?vue&type=script&lang=js"

import "./DependenciasMap.vue?vue&type=style&index=0&id=fbe141ec&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fbe141ec"]])

export default __exports__